/**
 * Resolve once the MSG91 OTP widget script (otp-provider.js) is loaded,
 * injecting it on demand and setting window.msg91ScriptLoaded, which
 * AuthModal's init loop polls.
 *
 * Loaded when the auth modal OPENS, not at page load: the eager copy cost
 * about 1s of main thread on every page for a script only the login flow
 * uses (GSC CrUX: all 42 URLs poor on INP, 2026-10-13). The modal shows its
 * own spinner while this resolves, and the 12s budget matches the init
 * loop's own 40 x 300ms wait.
 *
 * Same failed-tag cleanup as ensureRazorpay: a tag whose load or error event
 * already fired never fires again, so a failure removes the tag and the next
 * modal open injects a fresh one.
 */
export const ensureMsg91 = (timeoutMs = 12000): Promise<void> =>
  new Promise((resolve, reject) => {
    const w = window as any;
    const ready = () => typeof w.initSendOTP === "function";
    const markAndResolve = () => {
      w.msg91ScriptLoaded = true;
      resolve();
    };
    if (ready()) return markAndResolve();
    const SRC = "https://verify.msg91.com/otp-provider.js";

    let s = document.querySelector(
      `script[src="${SRC}"]`,
    ) as HTMLScriptElement | null;

    const fail = (err: Error) => {
      window.clearTimeout(t);
      if (s && !ready()) s.remove();
      reject(err);
    };
    const t = window.setTimeout(() => {
      if (ready()) return markAndResolve();
      fail(new Error("msg91_script_timeout"));
    }, timeoutMs);
    const done = () => {
      window.clearTimeout(t);
      markAndResolve();
    };

    if (!s) {
      s = document.createElement("script");
      s.src = SRC;
      s.async = true;
      document.body.appendChild(s);
    }
    s.addEventListener("load", done);
    s.addEventListener("error", () => fail(new Error("msg91_script_failed")));
  });
